import { render, staticRenderFns } from "./userauth.vue?vue&type=template&id=6e81e631&scoped=true"
import script from "./userauth.vue?vue&type=script&lang=js"
export * from "./userauth.vue?vue&type=script&lang=js"
import style0 from "./userauth.vue?vue&type=style&index=0&id=6e81e631&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e81e631",
  null
  
)

export default component.exports